import React, { useState, useEffect } from 'react';
import './SiteFooter.css';

const INSTAGRAM_WIDGET_ID = 'd46dfcb3-0b19-40aa-807d-e866518ddca8';
const REVIEWS_WIDGET_ID   = '4924ee2b-fef5-452c-8522-0ca7bc5dc46f';

const SiteFooter: React.FC = () => {
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);

  useEffect(() => {
    (window as any).eapps?.AppsManager?.reload();
  }, []);

  const handleSubscribe = (e: React.FormEvent) => {
    e.preventDefault();
    if (email) {
      console.log('Subscribe:', email);
      setSubscribed(true);
      setEmail('');
    }
  };

  return (
    <footer className="sf-footer">

      {/* ── Main 3-column section ── */}
      <div className="sf-main">

        {/* Column 1 — Logo, description, nav, social, badges */}
        <div className="sf-col sf-col--info">
          <a href="https://sailarmada.com" target="_blank" rel="noopener noreferrer" className="sf-logo">
            <img
              src="https://sailarmada.com/wp-content/uploads/2022/05/Logo-Alb-Transparent-200X44-px.png"
              alt="Sail Armada"
              width={201}
              height={44}
            />
          </a>

          <p className="sf-desc">
            We are passionate about offering you the finest sailing experience and
            premium quality holiday packages. We provide the ideal setting for you
            to create priceless memories that last a lifetime.
          </p>

          <nav className="sf-nav" aria-label="Footer navigation">
            <a href="https://sailarmada.com/how-it-works/" target="_blank" rel="noopener noreferrer">How it works</a>
            <a href="https://sailarmada.com/private-sailing/" target="_blank" rel="noopener noreferrer">Private sailing</a>
            <a href="https://sailarmada.com/group-sailing-holidays/" target="_blank" rel="noopener noreferrer">Group Sailing</a>
            <a href="https://sailarmada.com/faq/" target="_blank" rel="noopener noreferrer">FAQ</a>
            <a href="https://sailarmada.com/privacy/" target="_blank" rel="noopener noreferrer">Privacy</a>
            <a href="https://sailarmada.com/wp-content/uploads/2022/10/Licenta-Turism_Sail-Armada.jpg" target="_blank" rel="noopener noreferrer">Travel licence</a>
            <a href="https://sailarmada.com/wp-content/uploads/2024/05/Polita-I58063-scaled.jpg" target="_blank" rel="noopener noreferrer">Insurance</a>
          </nav>

          <div className="sf-social" role="list" aria-label="Social media links">
            <a href="https://www.facebook.com/sailarmadaholiday" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="sf-social__icon sf-social__icon--fb">
              <svg viewBox="0 0 24 24" fill="currentColor"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/></svg>
            </a>
            <a href="https://www.youtube.com/channel/UC19uHmQurVkz-yeL-mRQsXw" target="_blank" rel="noopener noreferrer" aria-label="YouTube" className="sf-social__icon sf-social__icon--yt">
              <svg viewBox="0 0 24 24" fill="currentColor"><path d="M22.54 6.42a2.78 2.78 0 0 0-1.95-1.96C18.88 4 12 4 12 4s-6.88 0-8.59.46A2.78 2.78 0 0 0 1.46 6.42 29 29 0 0 0 1 12a29 29 0 0 0 .46 5.58 2.78 2.78 0 0 0 1.95 1.96C5.12 20 12 20 12 20s6.88 0 8.59-.46a2.78 2.78 0 0 0 1.95-1.96A29 29 0 0 0 23 12a29 29 0 0 0-.46-5.58z"/><polygon fill="#0d0d0d" points="9.75 15.02 15.5 12 9.75 8.98 9.75 15.02"/></svg>
            </a>
            <a href="https://www.instagram.com/sail_armada/" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="sf-social__icon sf-social__icon--ig">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"/><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/></svg>
            </a>
            <a href="https://www.tripadvisor.com/Attraction_Review-g189460-d16630416-Reviews-Sail_Armada-Lefkada_Ionian_Islands.html" target="_blank" rel="noopener noreferrer" aria-label="TripAdvisor" className="sf-social__icon sf-social__icon--ta">
              <svg viewBox="0 0 24 24" fill="currentColor"><path d="M12.006 4.295c-2.978 0-5.982.87-8.344 2.613L0 6.908l2.39 2.089c-.65.998-.998 2.13-.998 3.262 0 3.33 2.71 6.045 6.045 6.045 1.485 0 2.907-.563 3.986-1.54l.583.936.583-.936c1.079.977 2.5 1.54 3.986 1.54 3.33 0 6.045-2.715 6.045-6.045 0-1.132-.348-2.264-.998-3.262L24 6.908l-3.662-.003C17.975 5.165 14.984 4.295 12.006 4.295zM5.436 8.775a3.3 3.3 0 1 1 0 6.6 3.3 3.3 0 0 1 0-6.6zm13.128 0a3.3 3.3 0 1 1 0 6.6 3.3 3.3 0 0 1 0-6.6zM5.436 10.23a1.845 1.845 0 1 0 0 3.69 1.845 1.845 0 0 0 0-3.69zm13.128 0a1.845 1.845 0 1 0 0 3.69 1.845 1.845 0 0 0 0-3.69z"/></svg>
            </a>
            <a href="https://www.tiktok.com/@sail_armada" target="_blank" rel="noopener noreferrer" aria-label="TikTok" className="sf-social__icon sf-social__icon--tk">
              <svg viewBox="0 0 24 24" fill="currentColor"><path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1V9.01a6.33 6.33 0 0 0-.79-.05 6.34 6.34 0 0 0-6.34 6.34 6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.33-6.34V8.69a8.18 8.18 0 0 0 4.78 1.52V6.75a4.85 4.85 0 0 1-1.01-.06z"/></svg>
            </a>
          </div>

          <div className="sf-badges">
            <a href="https://capetan.club/" target="_blank" rel="noopener noreferrer">
              <img
                src="https://sailarmada.com/wp-content/uploads/2022/05/capetan.png"
                alt="Capetan — Skippers Elite"
                className="sf-badge-capetan"
              />
            </a>
            <a href="https://charterfairtrag.de/charterfirmen-checked-and-trusted/" target="_blank" rel="noopener noreferrer">
              <img
                src="https://sailarmada.com/wp-content/uploads/elementor/thumbs/CHECKED-TRUSTED-FINANCIAL-SECURITY-SYSTEM-2026-rgtso5v4yvjw8eqj0gxndhq25295tgxz6enww9fffs.png"
                alt="Checked & Trusted — Financial Security System 2026"
                className="sf-badge-trust"
              />
            </a>
          </div>
        </div>

        {/* Column 2 — Instagram feed */}
        <div className="sf-col sf-col--instagram">
          <h4 className="sf-col-title">Check our Instagram</h4>
          <div className={`elfsight-app-${INSTAGRAM_WIDGET_ID}`} />
        </div>

        {/* Column 3 — Contact info, subscribe, reviews */}
        <div className="sf-col sf-col--contact">
          <h4 className="sf-col-title">Contact Info</h4>

          <ul className="sf-contact">
            <li><a href="tel:+40744276232">Call +40-744-ARMADA</a></li>
            <li><a href="mailto:hello@sailarmada.com">Email: hello@sailarmada.com</a></li>
            <li>Calea Vitan 119</li>
            <li>Bucharest — Romania</li>
            <li>9am — 5pm (Mon-Fri) Closed on Bank Holidays</li>
            <li>CUI: RO43792745 • J40/3275/2021</li>
          </ul>

          <form className="sf-subscribe" onSubmit={handleSubscribe}>
            {subscribed ? (
              <p className="sf-subscribe__thanks">Thanks for subscribing!</p>
            ) : (
              <>
                <input
                  type="email"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  placeholder="Your Email Address"
                  required
                  className="sf-subscribe__input"
                />
                <button type="submit" className="sf-subscribe__btn">Subscribe</button>
              </>
            )}
          </form>

          <div className="sf-reviews-row">
            <div className={`elfsight-app-${REVIEWS_WIDGET_ID}`} />
            <a
              href="https://partner.booking.com"
              target="_blank"
              rel="noopener noreferrer"
              className="sf-booking-badge"
            >
              <img
                src="https://sailarmada.com/wp-content/uploads/2022/05/gp_3529-150x150-1.png"
                alt="Booking.com Golden Partner"
                width={150}
                height={150}
              />
            </a>
          </div>
        </div>

      </div>

      {/* ── Legal bar ── */}
      <div className="sf-legal">
        <div className="sf-legal__links">
          <a href="https://sailarmada.com/cookie-policy/" target="_blank" rel="noopener noreferrer">Cookie Policy</a>
          <span>•</span>
          <a href="https://anpc.ro/" target="_blank" rel="noopener noreferrer">ANPC</a>
          <span>•</span>
          <a href="https://anpc.ro/ce-este-sal/" target="_blank" rel="noopener noreferrer">ANPC-SAL</a>
          <span>•</span>
          <a href="https://sailarmada.com/privacy/" target="_blank" rel="noopener noreferrer">Privacy Agreement</a>
          <span>•</span>
          <a href="https://sailarmada.com/termeni-si-conditii/" target="_blank" rel="noopener noreferrer">Terms &amp; Conditions</a>
        </div>
        <div className="sf-legal__anpc">
          <a href="https://anpc.ro/ce-este-sal/" target="_blank" rel="noopener noreferrer">
            <img src="https://sailarmada.com/wp-content/uploads/2023/09/pictograma-anpc.png" alt="ANPC SAL" height={37} />
          </a>
          <a href="https://ec.europa.eu/consumers/odr/main/index.cfm?event=main.home2.show&lng=EN" target="_blank" rel="noopener noreferrer">
            <img src="https://sailarmada.com/wp-content/uploads/2023/09/anpc-sol-e1696001473352.png" alt="SOL" height={39} />
          </a>
        </div>
      </div>

      {/* ── Bottom copyright bar ── */}
      <div className="sf-bottom">
        <p>
          SailArmada ® registered trademark of Travel Agency Sail Armada S.R.L. — All rights reserved /{' '}
          <a href="https://sailarmada.com/wp-content/uploads/2022/10/Licenta-Turism_Sail-Armada.jpg" target="_blank" rel="noopener noreferrer">Travel licence Nr. 2418</a>
          {' / '}
          <a href="https://sailarmada.com/wp-content/uploads/2025/05/Polita-I59665-scaled.jpg" target="_blank" rel="noopener noreferrer">Insurance Policy I59665</a>
          {' / '}
          <a href="https://sailarmada.com/wp-content/uploads/2022/10/Contract-cu-turistul.pdf" target="_blank" rel="noopener noreferrer">Tourist contract</a>
        </p>
        <p>Copyright © All rights reserved 2010-2026</p>
      </div>

    </footer>
  );
};

export default SiteFooter;
